import { Box, Button, Card, CardActions, CardContent, CardHeader, Checkbox, Collapse, FormControlLabel, Grid/*, useTheme*/ } from "@mui/material";
import React, { ReactNode/*, useEffect, useState */ } from "react";
import { useTranslation } from "react-i18next";
import { AlarmSetpointUsageItem } from "./AlarmSetpointUsageList";
import ExpandMore from "@mui/icons-material/ExpandMore";
// import FormCheckbox from "../../forms/form-checkbox/FormCheckbox";
// import { useFieldArray, useFormContext } from "react-hook-form";
// import { SetpointFormType } from "../AlarmSetpointEditorUtils";
import { isMobile, isTablet } from "react-device-detect";
import { IEditTagSearchResultDeviceDTO, IEditTagSearchResultTagDTO } from "../../../services/setpoint-administration-service/Models";

export type AlarmSetpointUsageListItemProps = {
    // name: 'devices' | 'wells' | 'tanks' | 'tankBatteries',
    item: AlarmSetpointUsageItem,
    // openUsage: boolean;
    // tagFilter: string;
    // showSelected: boolean;
    onExpandClick?: (obj: IEditTagSearchResultDeviceDTO) => void;
    onTagClick?: (tag: IEditTagSearchResultTagDTO) => void;
}

export function AlarmSetpointUsageListItem({
    // name,
    item,
    // openUsage,
    // tagFilter,
    // showSelected,
    onExpandClick,
    onTagClick
}: AlarmSetpointUsageListItemProps) {

    const isPhone = isMobile && !isTablet;

    // const [expanded, setExpanded] = useState(openUsage);
    // const theme = useTheme();
    const { t } = useTranslation();

    const expanded = item.expanded;

    // const {
    //     //getValues,
    //     watch,
    //     //trigger,
    //     control,
    //     //getValues,
    //     trigger,
    //     //reset,
    //     setValue,
    //     //resetField
    // } = useFormContext<SetpointFormType>();    

    // //const setpoint = useWatch({ control: control }) as SetpointFormType;

    // // const list = item.objectTypeID === eLynxObjectTypeEnum.Device ? setpoint.devices :
    // //                 item.objectTypeID === eLynxObjectTypeEnum.Well ? setpoint.wells : 
    // //                 item.objectTypeID === eLynxObjectTypeEnum.Tank ? setpoint.tanks : 
    // //                 setpoint.tankBatteries;


    // const { fields: list,
    // // remove, 
    // // append 
    // } = useFieldArray({
    //     control,
    //     name: `${name}`,
    //     keyName: 'fieldKey'
    //   });


    // // we need the 'real' index of the item
    // const index = list.findIndex(o => o.id === item.id);

    // const { fields: tags } = useFieldArray({
    //     control,
    //     name: `${name}.${index}.tags`,
    //     keyName: 'fieldKey1'
    //   });

    //   const watchTags = watch(`${name}.${index}.tags`)

    //   const linkedTags = watchTags.filter(o => o.selected);

    //   const filteredTags = tags
    //                           .filter(o => o.name.toLowerCase().indexOf(tagFilter.toLowerCase()) !== -1 || 
    //                                     tagFilter.toLowerCase().trim() === '')
    //                            .filter(o => o.selected || !showSelected);

    function getTitle(): ReactNode {
        return (
            <Box>
                {item.name}
            </Box>
        );
    }

    function renderTags() {

        // const usageObject = list[index];
        
        return item.tags?.map(tag => {

            // need the 'real' index for the form data
            //const tagIndex = usageObject.tags.findIndex(v => v.id === o.id);

            return (
                <Grid
                    key={tag.id}
                    sx={{
                        paddingTop: theme => `${theme.spacing(1)}!important`,
                    }}
                    size={{
                        xs: 2,
                        sm: 2,
                        md: 3
                    }}>
                    <FormControlLabel
                        sx={{
                            marginTop: 0,
                        }}
                        control={
                            <Checkbox
                                checked={tag.selected}
                                onChange={
                                    (_event, checked) => {
                                        onTagClick?.({ ...tag, selected: checked });
                                    }
                                }
                            />
                        }
                        label={tag.name ?? ''}
                        labelPlacement="end"
                    />
                </Grid>
            );
        });
    }

    // function toggleExpanded() {

    //     setExpanded(!expanded);

    //     setValue(`${name}.${index}.expanded`, !expanded);

    //     trigger();
    // }

    // useEffect(() => {

    //     setExpanded(openUsage);
    //     setValue(`${name}.${index}.expanded`, openUsage);

    // }, [
    //     openUsage,
    //     setExpanded,
    //     setValue,
    //     name,
    //     index,
    //     trigger
    // ]);

    return (
        <Card variant="outlined">
            <CardHeader
                sx={{
                    padding: 1
                }}
                subheader={getTitle()}
            >
            </CardHeader>
            <CardActions sx={{ paddingTop: 0, paddingBottom: 0 }}>
                <Button
                    sx={{
                        color: "text.primary"
                    }}
                    variant="text"
                    onClick={() => onExpandClick?.(item)}
                    style={{ marginLeft: "auto" }}
                    endIcon={
                        <ExpandMore
                            sx={{
                                transform: !item.expanded ? "rotate(0deg)" : "rotate(180deg)",
                                transition: theme => theme.transitions.create('transform', {
                                    duration: theme.transitions.duration.shortest,
                                })
                            }}
                        />
                    }
                >
                    {t('setpointAdmin.usage', {
                        count: item.selectedTagsCount ?? 0
                    })}
                </Button>
            </CardActions>

            <Collapse in={expanded} timeout="auto">

                <CardContent sx={{
                    padding: isPhone ? (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important` : undefined,
                }}>

                    {/* <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 2, sm: 4, md: 12}}> */}
                    <Grid container spacing={{ xs: 3, md: 4 }} columns={{ xs: 2, sm: 4, md: 12 }} sx={{ marginTop: -4 }}>
                        {
                            expanded &&
                                renderTags()
                        }
                    </Grid>
                </CardContent>
            </Collapse>
        </Card>
    );
}